const { createStore } = require('./Store');
const { HomeReducer } = require('./Reducers');
const { HomeState } = require('./States');
const { HomeActions } = require('./Actions');

const [HomeProvider, useHomeDispatch, useHomeStore] = createStore(
  HomeReducer,
  HomeState,
  HomeActions
);
export { HomeProvider, useHomeDispatch, useHomeStore };
